<template>
  <div class="go-in">
    <!-- banner -->
    <banner content="物理空间物理空间物理空间物理空间" title="物理空间" type="7"/>
    <template v-if="width >= 1200">
      <div class="bodyWidth">
        <!-- 社会心理服务基地 -->
        <div class="mentalHealths">
          <div class="title">社会心理服务基地类</div>
          <!-- <div class="healthBig"> -->
                <el-carousel indicator-position="outside" style="width:1440px" height="350px">
                        <el-carousel-item class="el-car-item" v-for="(list, index) in communityPic" :key="index">
                            <div class="bottomImgs">
                                <img style="border-radius: 10px" class="imgBox" v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList" />
                            </div>
                        </el-carousel-item>
                    </el-carousel>
            <!-- <img style="border-radius: 10px" v-for="(item,index) in community.pictureList" :key="index" :src="imgserver + item" alt=""> -->
          <!-- </div> -->
        </div>
        <!-- 社会心理服务中心 -->
        <div class="central">
          <div class="title">心理健康中心（站、室）类</div>
          <div class="level-screening">
            <el-button
                v-for="(item,index) in levelList"
                :key="index"
                :class="index==itemType?'highlight':''"
                size="medium"
                type="primary"
                @click.prevent="materTay(index,item.code)"
            >
              {{ item.title }}
            </el-button
            >
          </div>
          <div class="healthBody">
            <div v-for="item in communityCentre.pictureList" v-if="itemType == 0" :key="item.id" class="body">
              <!-- <div class="text">
                <div class="healthtitle">{{ communityCentre.title }}</div>
              </div> -->
              <img :src="imgserver + item" alt="" style="border-radius: 15px;height:340px; border-radius: 10px">
            </div>
            <div v-for="item in communityEAP.pictureList" v-if="itemType == 1" :key="item.id" class="body">
              <!-- <div class="text">
                <div class="healthtitle">{{ communityEAP.title }}</div>
              </div> -->
              <img :src="imgserver + item" alt="" style="border-radius: 15px;height:340px;border-radius: 10px">
            </div>
            <div v-for="item in communityStudent.pictureList" v-if="itemType == 2" :key="item.id" class="body">
              <!-- <div class="text">
                <div class="healthtitle">{{ communityStudent.title }}</div>
              </div> -->
              <img :src="imgserver + item" alt="" style="height:340px;border-radius: 10px">
            </div>
          </div>
        </div>
        <!-- 社会心理服务工作室 -->
        <div class="concept">
          <div class="title">心理健康共享空间</div>
          <div class="img">
            <el-carousel :interval="5000" height="450px">
              <el-carousel-item v-for="item in space.pictureList" :key="item">
                <img :src="imgserver + item" alt="" style="width:100%;height:100%;border-radius: 10px;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </template>
    <template v-if="width <= 768">
      <div class="bodyWidth">
        <!-- 社会心理服务基地 -->
        <div class="mentalHealth">
          <div class="title">社会心理服务基地类</div>
          <div class="healthBig">
            <div v-for="(item,index) in community.pictureList" :key="index" style="width: 94%;margin: 0 auto;">
              <img style="border-radius: 10px" :src="imgserver + item" alt="">
            </div>

          </div>
        </div>
        <!-- 社会心理服务中心 -->
        <div class="central">
          <div class="title">心理健康中心（站、室）类</div>
          <div class="level-screening">
            <el-button
                v-for="(item,index) in levelList"
                :key="index"
                :class="index==itemType?'highlight':''"
                size="medium"
                type="primary"
                @click.prevent="materTay(index,item.code)"
            >
              {{ item.codeValue }}
            </el-button
            >
          </div>
          <div class="healthBody">
            <div v-for="item in communityCentre.pictureList" v-if="itemType == 0" :key="item.id" class="body">
              <div class="text">
                <div class="healthtitle">{{ communityCentre.title }}</div>
              </div>
              <img :src="imgserver + item" alt="" style="border-radius: 10px;height:340px;">
            </div>
            <div v-for="item in communityEAP.pictureList" v-if="itemType == 1" :key="item.id" class="body">
              <div class="text">
                <div class="healthtitle">{{ communityEAP.title }}</div>
              </div>
              <img :src="imgserver + item" alt="" style="border-radius: 10px;height:340px;">
            </div>
            <div v-for="item in communityStudent.pictureList" v-if="itemType == 2" :key="item.id" class="body">
              <div class="text">
                <div class="healthtitle">{{ communityStudent.title }}</div>
              </div>
              <img :src="imgserver + item" alt="" style="border-radius: 10px;height:340px">
            </div>
          </div>
        </div>
        <!-- 社会心理服务工作室 -->
        <div class="concept">
          <div class="title">心理健康共享空间</div>
          <div class="img">
            <el-carousel :interval="5000" height="450px">
              <el-carousel-item v-for="item in space.pictureList" :key="item">
                <img :src="imgserver + item" alt="" style="width:100%;height:100%;border-radius: 10px;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import {getspace} from '../api/api'

export default {
  data() {
    return {
      activeName: '1',
      levelList: [],
      activeIndex: 0,
      // 等级筛选数据
      itemType: 0, // 等级筛选选中的标识
      materialCode: '', // 分类的code值
      community: {},//社会心理服务基地
      communityPic: [],//社会心理服务基地
      communityCentre: {},//2-1
      communityEAP: {},//2-2
      communityStudent: {},//2-3
      space: {},//心理健康共享
      width: document.body.clientWidth,
    };
  },
  components: {
    Banner,
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.width = document.documentElement.clientWidth // 宽
      })()
    }
    // this.widths = window.screen.width
    getspace().then(res => {
      this.community = res.data.data.community
      this.communityPic = this.community.pictureList
      let newDataList = []
                let current = 0
                if(this.communityPic && this.communityPic.length>0){
                for(let i=0;i<=this.communityPic.length-1;i++){
                    if(i%3 !== 0 || i === 0 ){
                    if(!newDataList[current]){
                        newDataList.push([this.communityPic[i]])
                    }else{
                        newDataList[current].push(this.communityPic[i])
                    }
                    }else{
                    current++
                    newDataList.push([this.communityPic[i]])
                    }
                }
                }
                this.communityPic = [...newDataList]
      this.communityCentre = res.data.data.communityCentre
      this.communityEAP = res.data.data.communityEAP
      this.communityStudent = res.data.data.communityStudent
      this.levelList.push(this.communityCentre,this.communityEAP,this.communityStudent)
      this.space = res.data.data.space
    })
  },
  methods: {
    detail(id) {
      this.$router.push({
        path: '/earthDetail',
        query: {
          id: id
        }
      })
    },
    changeActive(e) {
      e.currentTarget.className = 'body is-active'
    },
    removeActive(e) {
      e.currentTarget.className = 'body';
    },
    // 等级筛选互斥效果
    materTay(itemType, code) {
      // 等级筛选选中的标识-高亮效果
      this.itemType = itemType
      // 分类的code值
      this.materialCode = code
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
}

.bodyWidth {
  width: 1440px;
  margin: 0 auto;
}

::v-deep .el-tabs__item {
  color: #666666 !important;
}

//公共样式
.title,
.eTitle {
  font-size: 30px;
  font-weight: normal;
  line-height: 60px;
  letter-spacing: 0px;
  color: #000000;
  text-align: center;
  margin-bottom: 20px;
}

::v-deep .el-carousel__button {
  width: 38px;
  height: 9px;
  border-radius: 35px;
  background: rgba(216, 216, 216, 0.55);
}

::v-deep .el-carousel__indicator.is-active button {
  background-color: #fff;
}

.mentalHealths {
  width: 1440px;
  box-sizing: border-box;
  padding-top: 60px;
  margin: 0 auto;
  .bottomImgs {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // flex-wrap: wrap;
    // flex: 3;
    img {
        width: 470px;
        height: 340px;
    }
  }
}

.central {
  width: 100%;
  box-sizing: border-box;
  padding: 40px 0;

  .level-screening {
    // padding-left: 40px;
    box-sizing: border-box;
    height: 40px;
    text-align: center;
    line-height: 80px;

    .el-button {
      background-color: #fff;
      // color: #34A59A;
      border-radius: 20px;
      color: #666666;
      padding: 10px;
      border-color: #f5f5f5;
      margin-right: 30px;
      box-shadow: 1px 1px 2px 1px #f5f5f5; 
    }

    .highlight {
      background: #34A59A !important;
      color: #fff;
    }
  }

  .healthBody {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex: 3;

    .body {
      //   width: 32.5%;
      //   height: 100%;
      margin-top: 50px;
      //   position: relative;
      box-sizing: border-box;
      //   padding: 30px !important;
      cursor: pointer;

      .text {
        width: 100%;
        // height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: end;
      }

      .healthtitle {
        font-size: 24px;
        color: #fff;
      }

      .detail {
        padding: 5px 10px;
        border-radius: 40px;
        border: 1px solid #FFFFFF;
        display: none;
      }

      img {
        // position: absolute;
        // top: 0;
        // left: 0;
        // width: 100%;
        // height: 100%;
        // z-index: -1;
        width: 470px;
        height: 340px;

      }
    }
  }
}

.workstation {
  width: 100%;
  //   height: 105vh;
  box-sizing: border-box;
  padding: 40px 0;

  .healthBody {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .body {
      width: 15.5%;
      height: 30vh;
      margin-top: 20px;
      position: relative;
      box-sizing: border-box;
      padding: 30px 0 30px 10px !important;
      cursor: pointer;

      .text {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: end;
      }

      .healthtitle {
        font-size: 18px;
        color: #fff;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
      }
    }
  }

  .platformImg {
    width: 100%;
    margin-top: 16px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .text {
      position: absolute;
      width: 35%;
      top: 0%;
      right: 10%;
      color: #fff;
      box-sizing: border-box;
      padding: 50px 0;

      .textTitle {
        font-size: 24px;
        font-weight: 500;
        line-height: 35px;
      }

      p {
        font-size: 14px;
        font-weight: normal;
        margin-top: 10px;
      }

      .el-button {
        background-color: transparent;
        border: 1px solid #FFFFFF;
        color: #fff;
        margin-top: 10px;
        // width: 105px;
      }
    }
  }
}

.concept {
  width: 100%;
  box-sizing: border-box;
  padding: 60px 0;

  .img {
    width: 100%;
    margin: 30px 0 50px 0;
  }

  p {
    font-size: 16px;
    font-weight: normal;
    line-height: 27px;
    letter-spacing: 0px;
    color: #666666;
  }
}

@media (max-width: 768px) {
  * {
    margin: 0;
    padding: 0;
  }
  .go-in {
    width: 100%;
    height: 100%;
  }
  .bodyWidth {
    width: 100%;
    margin: 0 auto;
  }
  ::v-deep .el-tabs__item {
    color: #666666 !important;
  }
  //公共样式
  .title,
  .eTitle {
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    color: #333333;
    text-align: center;
    margin-bottom: 20px;
  }
  ::v-deep .el-carousel__button {
    width: 38px;
    height: 9px;
    border-radius: 35px;
    background: rgba(216, 216, 216, 0.55);
  }
  ::v-deep .el-carousel__indicator.is-active button {
    background-color: #fff;
  }
  .mentalHealth {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 0;

    .healthBig {
      width: 100%;
      //display: flex;
      //justify-content: space-between;
      //flex-wrap: wrap;
      //flex:2;
      img {
        width: 100%;
        height: 196px;
        margin-top: 1px;
      }
    }
  }
  .central {
    width: 95%;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 40px 0;

    .level-screening {
      // padding-left: 40px;
      box-sizing: border-box;
      height: 40px;
      text-align: center;
      line-height: 80px;

      .el-button {
        background-color: #fff;
        // color: #34A59A;
        border-radius: 10px;
        color: #666666;
        box-sizing: border-box;
        padding: 10px;
        border-color: #f5f5f5;
        margin-right: 10px;
      }

      .highlight {
        background: #34A59A !important;
        color: #fff;
      }
    }

    .healthBody {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex: 3;

      .body {
        //   width: 32.5%;
        //   height: 100%;
        margin-top: 50px;
        //   position: relative;
        box-sizing: border-box;
        //   padding: 30px !important;
        cursor: pointer;

        .text {
          width: 100%;
          // height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: end;
        }

        .healthtitle {
          font-size: 24px;
          color: #fff;
        }

        .detail {
          box-sizing: border-box;
          //padding: 5px 10px;
          border-radius: 40px;
          border: 1px solid #FFFFFF;
          display: none;
        }

        img {
          // position: absolute;
          // top: 0;
          // left: 0;
          // width: 100%;
          // height: 100%;
          // z-index: -1;
          width: 100%;
          height: 340px;

        }
      }
    }
  }
  .workstation {
    width: 100%;
    //   height: 105vh;
    box-sizing: border-box;
    padding: 40px 0;

    .healthBody {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .body {
        width: 15.5%;
        height: 30vh;
        margin-top: 20px;
        position: relative;
        box-sizing: border-box;
        padding: 30px 0 30px 10px !important;
        cursor: pointer;

        .text {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: end;
        }

        .healthtitle {
          font-size: 18px;
          color: #fff;
        }

        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: -1;
        }
      }
    }

    .platformImg {
      width: 100%;
      margin-top: 16px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }

      .text {
        position: absolute;
        width: 35%;
        top: 0%;
        right: 10%;
        color: #fff;
        box-sizing: border-box;
        padding: 50px 0;

        .textTitle {
          font-size: 24px;
          font-weight: 500;
          line-height: 35px;
        }

        p {
          font-size: 14px;
          font-weight: normal;
          margin-top: 10px;
        }

        .el-button {
          background-color: transparent;
          border: 1px solid #FFFFFF;
          color: #fff;
          margin-top: 10px;
          // width: 105px;
        }
      }
    }
  }
  .concept {
    width: 100%;
    box-sizing: border-box;
    padding: 60px 0;

    .img {
      width: 100%;
      margin: 30px 0 50px 0;
    }

    p {
      font-size: 16px;
      font-weight: normal;
      line-height: 27px;
      letter-spacing: 0px;
      color: #666666;
    }
  }
}
</style>
